import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { Club } from '../store';

@Injectable()
export class ClubService {


  private _api = '/api/Club';

  constructor(
    private hs: HttpService
  ) { }

  getClubOverallScore(clubID: number) {
    return this.hs.get(`${this._api}/getMatchesStat/${clubID}`);
  }

  getClubTeamsStat(clubID: number) {
    return this.hs.get(`${this._api}/getClubTeamsStat/${clubID}`);
  }

  getJerseyLogo(logoID: number) {
    return this.hs.get(`${this._api}/getJerseyLogo/${logoID}`);
  }

  updateClub(club: Club) {
    return this.hs.post(`${this._api}/updateClub`, club);
  }

  getProductUsageData(clubID: number) {
    return this.hs.get(`${this._api}/getClubProductUsage/${clubID}`);
  }

  getPlayerPositions(clubID: number) {
    return this.hs.get(`${this._api}/positions-list/${clubID}`);
  }

  getClubProducts(clubID: number) {
    return this.hs.get(`${this._api}/get-club-product-list/${clubID}`);
  }

  getAllTGSStatusUpdates() {
    return this.hs.get(`${this._api}/get-all-tgs-status-updates`);
  }

  getClubEventsByID(clubID: number) {
    return this.hs.get(`${this._api}/get-club-event-list-by-id/${clubID}`);
  }

  getClubEventTeamsByEventIdAndClubId(eventID: number, clubID: number,teamType: string, gender: string) {
    return this.hs.get(`${this._api}/get-club-event-teams-by-eventid-and-clubid/${eventID}/${clubID}/${teamType}/${gender}`)
  }
  createPlayerRelease(obj) {
    return this.hs.post(`${this._api}/create-player-release`, obj);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/club.service.ts